module.exports = __webpack_public_path__ + "img/更可靠.21f40914.png";